import { ReactElement } from 'react';
import { documentationEmpty } from 'assets/icons';
import { InfoBanner } from 'components/general/InfoBanner';
import {
  EmptyListReason,
  EmptyTableInfo,
} from 'components/common/noTableContentInfo/NoTableContentInfo';

export function InspectionEmpty({
  searchPhrase,
}: {
  searchPhrase: string;
}): ReactElement {
  return searchPhrase ? (
    <EmptyTableInfo
      emptyTableReason={EmptyListReason.SEARCHPHRASE_MISMATCH}
    />
  ) : (
    <InfoBanner
      icon={documentationEmpty}
      messageId='inspection_empty_info'
      dataQa='inspection_empty'
    />
  );
}
